export const NEWSLETTER_CONFIRM_PATH = '/confirm-newsletter';
export const NEWSLETTER_CONFIRM_CODE_PARAM = 'code';
export const NEWSLETTER_CONFIRM_STATUS_PARAM = 'newsletterConfirm';

export type NewsletterConfirmStatus = 'success' | 'error';

export function readNewsletterConfirmCode(searchParams: URLSearchParams): string | null {
    const code = searchParams.get(NEWSLETTER_CONFIRM_CODE_PARAM)?.trim() ?? '';
    return code || null;
}

export function readNewsletterConfirmStatus(searchParams: URLSearchParams): NewsletterConfirmStatus | null {
    const status = searchParams.get(NEWSLETTER_CONFIRM_STATUS_PARAM);
    return status === 'success' || status === 'error' ? status : null;
}

export function buildNewsletterConfirmationUrl(publicOrigin: string): string {
    return `${publicOrigin.replace(/\/$/, '')}${NEWSLETTER_CONFIRM_PATH}/?${NEWSLETTER_CONFIRM_CODE_PARAM}=`;
}

export function buildNewsletterConfirmHomeRedirect(status: NewsletterConfirmStatus): string {
    return `/?${NEWSLETTER_CONFIRM_STATUS_PARAM}=${status}`;
}
